import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const PromoteGlobalPage = lazy(() =>
  import('../../pages/admin/promote-global/PromoteGlobalPage').then((m) => ({
    default: m.PromoteGlobalPage,
  })),
);

export const Route = createFileRoute('/admin/promote-global')({
  component: () => (
    <Suspense
      fallback={
        <Spinner
          style={{
            position: 'absolute',
            top: '25%',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />
      }
    >
      <PromoteGlobalPage />
    </Suspense>
  ),
});
